/* 和 FV 30秒（2026-10-03）。実写の一杯 → 版画に刷り変わる → 二人の物語 → 実写の三種。
   ・動画は画面いっぱい（切り抜き表示）。店名・題簽・ボタン・スクロールの案内はページの文字として重ね、動画の時間に合わせて出し入れする。
     0〜4.2秒：ロゴ・題簽（3.65秒に朱の印が押される）／4.2〜25.3秒：ロゴと、袋・湯せん・麺の場面の短冊（題簽と同じ場所）／25.3秒〜：題簽が戻り、26秒からボタン。
     文字はすべてここ（ページ）に置き、動画には会話だけを入れる（画面の形で切り抜きが変わっても、ロゴと重ならない）。
   ・ヘッダーはFVの間は隠し、スクロールで出す（これまでと同じ）。画面の外では止める。動きを減らす設定では刷り上がりの絵で止めて全部を出す。
   縦長の画面（スマホ・縦置きのタブレット）は縦の動画（9:16）、横長の画面は横の動画（16:9）。
   要素名は kazu-fv22 のまま（ヘッダーの切り替えなどの決まりを引き継ぐ）。 */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('kazu-fv22')) return;
  const DUR = 30, OPEN_END = 4.2, SEAL_AT = 3.65, END_AT = 25.3, CTA_AT = 26.0;
  /* 短冊（左の列・題簽と同じ場所）：袋／湯せん／麺の場面 */
  const SLIPS = [[7.5, 9.5], [10.45, 12.4], [13.1, 14.3]];

  class KazuFV extends HTMLElement {
    connectedCallback() {
      if (this._active) return;
      this._active = true;
      this._time = 0; this._ended = false; this._userPaused = false; this._inView = false; this._modeStates = {};
      this._mount = this.querySelector('[data-kazu-fv22-mount]');
      this._control = this.querySelector('[data-kazu-fv22-control]');
      /* 縦長の画面（スマホ・縦のタブレット）は縦の動画、横長は横の動画 */
      this._mobile = window.matchMedia('(max-aspect-ratio: 1/1)');
      this._reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._header = document.querySelector('.shopify-section--header');
      this._headerWasInert = this._header ? this._header.inert : false;
      this._onScroll = () => {
        this._scrolling = true;
        clearTimeout(this._scrollEndTimer);
        if (!this._headerFrame) this._headerFrame = requestAnimationFrame(() => { this._headerFrame = null; this._syncHeader(); });
        this._scrollEndTimer = setTimeout(() => { this._scrolling = false; this._syncHeader(); }, 280);
      };
      this._onControl = this._handleControl.bind(this);
      this._onVisibility = this._syncPlayback.bind(this);
      this._onMode = this._changeMode.bind(this);
      this._onReduced = this._changeReduced.bind(this);
      this._onViewport = this._fitViewport.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onViewport);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', this._onViewport);
      this._control.addEventListener('click', this._onControl);
      document.addEventListener('visibilitychange', this._onVisibility);
      this._mobile.addEventListener('change', this._onMode);
      this._reduced.addEventListener('change', this._onReduced);
      if (window.IntersectionObserver) {
        this._io = new IntersectionObserver((es) => { this._inView = es.some((e) => e.isIntersecting && e.intersectionRatio > 0); this._syncPlayback(); }, { threshold: [0, 0.01] });
        this._io.observe(this);
      } else this._inView = true;
      this._fitViewport();
      this._setPhase(0);
      if (this._reduced.matches) this._showStatic(); else this._buildVideo();
    }

    disconnectedCallback() {
      if (!this._active) return;
      this._active = false;
      this._dispose();
      if (this._io) this._io.disconnect();
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onViewport);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', this._onViewport);
      clearTimeout(this._scrollEndTimer); cancelAnimationFrame(this._headerFrame);
      document.documentElement.classList.remove('kazu-fv-immersive');
      document.documentElement.removeAttribute('data-kazu-fv-header');
      if (this._header) this._header.inert = this._headerWasInert;
      this._control.removeEventListener('click', this._onControl);
      document.removeEventListener('visibilitychange', this._onVisibility);
      this._mobile.removeEventListener('change', this._onMode);
      this._reduced.removeEventListener('change', this._onReduced);
    }

    _syncHeader() {
      if (!this._active) return;
      const root = document.documentElement;
      root.classList.toggle('kazu-fv-immersive', !!this._header);
      if (!this._header) return;
      const past = this.getBoundingClientRect().bottom <= 2;
      const state = !past ? 'hidden' : this._scrolling ? 'scrolling' : 'idle';
      root.setAttribute('data-kazu-fv-header', state);
      this._header.inert = state === 'hidden' || this._headerWasInert;
    }

    /* 画面の高さいっぱい（プレビュー用の下のバーがあれば、その分を引く） */
    _fitViewport() {
      if (!this._active) return;
      this._syncHeader();
      const sh = Math.min(window.innerHeight, window.visualViewport ? window.visualViewport.height : window.innerHeight);
      const top = Math.max(0, this.getBoundingClientRect().top + window.scrollY);
      const bar = document.getElementById('PBarNextFrameWrapper');
      const br = bar ? bar.getBoundingClientRect() : null;
      const bottom = br && br.width > 0 && br.bottom >= sh - 2 ? Math.max(0, sh - br.top) : 0;
      const h = Math.max(320, Math.round(sh - top - bottom)) + 'px';
      if (this.style.getPropertyValue('--kazu-fv-h') !== h) this.style.setProperty('--kazu-fv-h', h);
    }

    /* 文字の出し入れ（動画の時間に合わせる） */
    _setPhase(t) {
      const phase = t < OPEN_END ? 'open' : t < END_AT ? 'story' : 'end';
      if (this.getAttribute('data-fv-phase') !== phase) this.setAttribute('data-fv-phase', phase);
      this.toggleAttribute('data-fv-sealed', t >= SEAL_AT);
      this.toggleAttribute('data-fv-cta', t >= CTA_AT);
      const n = SLIPS.findIndex(([a, b]) => t >= a && t < b) + 1;
      if (this.getAttribute('data-fv-slip') !== String(n || '')) { if (n) this.setAttribute('data-fv-slip', String(n)); else this.removeAttribute('data-fv-slip'); }
    }

    _dispose() {
      cancelAnimationFrame(this._raf);
      clearTimeout(this._loadTimeout);
      if (this._video) { this._video.pause(); this._video.removeAttribute('src'); this._video.load(); this._video.remove(); }
      this._video = null;
      this.removeAttribute('data-kazu-fv22-ready');
      if (this._control) this._control.hidden = true;
    }

    _buildVideo() {
      this._dispose();
      if (!this._active || this._reduced.matches) return;
      const mobile = this._mobile.matches;
      this._mode = mobile ? 'mobile' : 'desktop';
      const v = document.createElement('video');
      v.className = 'kazu-fv30__video';
      v.id = this.id + '-film';
      v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      v.setAttribute('aria-label', 'スープを注ぐ一杯が版画に刷り変わり、二人が冷凍の沖縄そばを作って味わう30秒の物語');
      v.preload = 'auto'; v.loop = false;
      v.poster = this.getAttribute(mobile ? 'data-kazu-fv-mobile-poster' : 'data-kazu-fv-poster');
      this._mount.append(v);
      this._video = v;
      this._control.setAttribute('aria-controls', v.id);
      let ready = false, pending = false;
      const tick = () => {
        if (!this._video || this._video !== v) return;
        this._setPhase(v.currentTime);
        if (!v.paused) this._raf = requestAnimationFrame(tick);
      };
      v.addEventListener('play', () => { cancelAnimationFrame(this._raf); this._raf = requestAnimationFrame(tick); });
      v.addEventListener('seeked', () => this._setPhase(v.currentTime));
      v.addEventListener('timeupdate', () => this._setPhase(v.currentTime));
      v.addEventListener('loadedmetadata', () => { if (this._time > 0) v.currentTime = Math.min(this._time, DUR - .01); }, { once: true });
      v.addEventListener('loadeddata', () => {
        if (ready || this._video !== v) return;
        ready = true; clearTimeout(this._loadTimeout);
        this.setAttribute('data-kazu-fv22-ready', '');
        this._control.hidden = false;
        this._setPhase(v.currentTime);
        this._syncPlayback();
      }, { once: true });
      v.addEventListener('ended', () => { this._time = DUR; this._ended = true; this._setPhase(DUR); this._syncPlayback(); });
      v.addEventListener('error', () => this._fail(), { once: true });
      this._api = {
        play: () => {
          if (!ready || pending || !v.paused || this._autoplayBlocked) return;
          pending = true;
          v.play().catch((e) => {
            /* 自動再生を止められたとき（iPhoneの低電力モードなど）：最初のコマのまま、印とボタンは出しておく（2026-10-03）。「動画を再生」で物語に戻る */
            if (e.name !== 'AbortError') { this._autoplayBlocked = true; this._userPaused = true; this.setAttribute('data-fv-sealed', ''); this.setAttribute('data-fv-cta', ''); this._syncPlayback(); }
          }).finally(() => { pending = false; });
        },
        pause: () => v.pause(),
        seek: (t) => { v.currentTime = Math.max(0, Math.min(DUR - .01, t)); this._setPhase(t); },
        time: () => v.currentTime,
      };
      v.src = this.getAttribute(mobile ? 'data-kazu-fv-mobile-video' : 'data-kazu-fv-video');
      this._loadTimeout = setTimeout(() => { if (!ready) this._fail(); }, 30000);
      v.load();
    }

    _fail() { this._dispose(); this._showStatic(); }

    /* 動きを減らす設定・読み込めないとき：刷り上がりの絵で止め、題簽とボタンを出す */
    _showStatic() {
      this._ended = true;
      this.setAttribute('data-kazu-fv22-static', '');
      this.setAttribute('data-fv-phase', 'end');
      this.setAttribute('data-fv-sealed', ''); this.setAttribute('data-fv-cta', '');
    }

    _isVisible() {
      if (!this._inView || document.hidden || !this.isConnected) return false;
      return this.checkVisibility ? this.checkVisibility({ checkVisibilityCSS: true }) : true;
    }

    _syncPlayback() {
      if (!this._api || !this._video) return;
      const play = this._isVisible() && !this._userPaused && !this._ended && !this._reduced.matches;
      if (play) this._api.play(); else this._api.pause();
      const label = this._autoplayBlocked ? '動画を再生' : this._ended ? 'もう一度' : this._userPaused ? '再生' : '一時停止';
      this._control.textContent = label;
      this._control.setAttribute('aria-label', this._ended ? '30秒の紹介をもう一度再生' : this._userPaused ? '紹介を再生' : '紹介を一時停止');
    }

    _handleControl() {
      if (!this._api || this._reduced.matches) return;
      if (this._autoplayBlocked) { this._autoplayBlocked = false; this._userPaused = false; this._syncPlayback(); return; }
      if (this._ended) { this._ended = false; this._userPaused = false; this._time = 0; this._api.seek(0); }
      else this._userPaused = !this._userPaused;
      this._syncPlayback();
    }

    _changeMode() {
      this._fitViewport();
      if (this._api && this._video) this._modeStates[this._mode] = { time: this._api.time(), ended: this._ended, userPaused: this._userPaused };
      const next = this._mobile.matches ? 'mobile' : 'desktop';
      const st = this._modeStates[next] || { time: 0, ended: false, userPaused: false };
      this._time = st.time; this._ended = st.ended; this._userPaused = st.userPaused; this._autoplayBlocked = false;
      if (!this._reduced.matches) this._buildVideo();
    }

    _changeReduced() {
      if (this._reduced.matches) { this._dispose(); this._showStatic(); }
      else { this.removeAttribute('data-kazu-fv22-static'); this._ended = false; this._buildVideo(); }
    }
  }

  customElements.define('kazu-fv22', KazuFV);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('kazu-fv22[data-kazu-fv22]').forEach((el) => el.connectedCallback()));
  document.addEventListener('shopify:section:unload', (e) => e.target.querySelectorAll('kazu-fv22[data-kazu-fv22]').forEach((el) => el.disconnectedCallback()));
})();
